module.exports = __webpack_public_path__ + "static/media/hero-home.3bb4bf20.png";